// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-schedule-page {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 110%;
  max-width: 1900px;
  margin: 20px auto;
  min-height: 400px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.edit-schedule-main {
  max-width: 1400px;
  margin: 0 auto;
}

.edit-schedule-panel {
  background: white;
  border-radius: 10px;
  padding: 30px 0px 30px 0px;
}

/* верхняя панель */
.edit-schedule-top-panel {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

/* левая часть с кнопкой назад и выбором группы */
.left-panel-section {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 1;
}

.back-button {
  padding: 8px 16px;
  background: white;
  color: #002FA7;
  border: 1px solid #002FA7;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 450;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100px;
  height: 38px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.back-button:hover {
  background: #f0f3ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 47, 167, 0.1);
}

.group-selection {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.group-selection label {
  color: #002FA7;
  font-weight: 600;
  white-space: nowrap;
  margin-bottom: 0;
}

.group-select {
  min-width: 200px;
  padding: 8px 12px;
  border: 1px solid #002FA7;
  border-radius: 8px;
  font-size: 14px;
  color: #002FA7;
  background: white;
  cursor: pointer;
  transition: border-color 0.3s;
  height: 38px;
}

.group-select:focus {
  outline: none;
  border: 2px solid #002FA7;
  color: #002FA7;
}

/* расписание */
.schedule-grid-container {
  margin-bottom: 40px;
}

.schedule-grid {
  display: grid;
  grid-template-columns: 120px repeat(6, 1fr);
  gap: 1px;
  background: #e0e0e0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.grid-header {
  background: #002FA7;
  color: white;
  padding: 15px 5px;
  text-align: center;
  font-weight: 600;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}

.grid-header.empty {
  background: #f8f9fa;
}

.time-cell {
  background: white;
  padding: 10px;
  text-align: center;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.pair-number {
  font-weight: 600;
  color: #002FA7;
  margin-bottom: 5px;
  font-size: 14px;
}

.pair-time {
  font-size: 12px;
  color: #666;
}

.schedule-cell {
  background: white;
  padding: 8px;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  min-height: 100px;
  cursor: pointer;
  transition: background 0.3s;
}

.schedule-cell:hover {
  background: #f8f9fa;
}

.schedule-cell.selected {
  background: #e8f0ff;
  box-shadow: inset 0 0 0 2px #002FA7;
}

.schedule-cell.filled {
  background: #f0f7ff;
  cursor: pointer;
}

.schedule-cell.empty {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pair-info {
  font-size: 11px;
  line-height: 1.3;
}

.pair-info.both-weeks {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.week-label {
  font-weight: 600;
  font-size: 11px;
  color: #666;
  margin-bottom: 2px;
}

.pair-subject {
  font-weight: 600;
  color: #002FA7;
  margin-bottom: 2px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.1;
  font-size: 11px;
}

.pair-teacher {
  color: #333;
  margin-bottom: 2px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.1;
  font-size: 10px;
}

.pair-room {
  color: #666;
  font-style: italic;
  font-size: 10px;
  margin-bottom: 10px;
}

.add-pair-btn {
  color: #002FA7;
  font-weight: 500;
  padding: 5px 10px;
  border: 1px dashed #002FA7;
  border-radius: 4px;
  background: #f8f9fa;
  font-size: 12px;
  text-align: center;
}

/* статус баннеры */
.status-banner {
  background: #e3f2fd;
  color: #002FA7;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
}

.status-banner.error {
  background: #ffebee;
  color: #c62828;
}

/* панель редактирования пары */
.edit-pair-panel {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 25px;
  margin-top: 30px;
  border: 2px solid #e0e0e0;
}

.edit-pair-title {
  color: #002FA7;
  margin: 0 0 20px 0;
  font-size: 18px;
  line-height: 1.4;
}

/* первая строка - преподаватели, предметы, аудитории */
.edit-controls {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 30px;
}

.control-group h4 {
  color: #002FA7;
  margin: 0 0 15px 0;
  font-size: 16px;
}

/* поиск */
.search-box {
  margin-bottom: 15px;
  width: 100%;
}

.search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 2px rgba(0, 47, 167, 0.2);
}

.no-results {
  text-align: center;
  padding: 20px;
  color: #999;
  font-style: italic;
}

/* списки преподавателей, предметов и аудиторий */
.items-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  padding: 4px;
  overflow-x: visible !important;
  overflow-y: auto;
  z-index: 0;
}

.list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: white;
  color: #333;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  font-size: 14px;
  position: relative;
  flex-shrink: 0;
  overflow: visible !important;
}

.list-item:hover:not(.active):not(:disabled) {
  border-color: #002FA7;
  background: #f0f3ff;
}

.list-item.active {
  background: #002FA7;
  color: white;
  border-color: #002FA7;
}

.list-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f5f5f5;
}

.item-name {
  flex: 1 1;
  text-align: left;
}

/* привязанная аудитория преподавателя - зеленое выделение */
.list-item.owner-room {
  background: #e8f5e9;
  border-color: #4caf50;
  color: #2e7d32;
}

.list-item.owner-room:hover:not(.active):not(:disabled) {
  background: #c8e6c9;
  border-color: #4caf50;
  color: #1b5e20;
}

.list-item.owner-room.active {
  background: #002FA7;
  color: white;
  border-color: #002FA7;
}

/* иконка примечания */
.item-note-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: help;
  flex-shrink: 0;
}

.item-note-icon {
  width: 20px;
  height: 20px;
  transition: opacity 0.2s;
}

.item-note-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  background: white;
  color: #002FA7;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: normal;
  white-space: normal;
  min-width: 200px;
  max-width: 350px;
  width: max-content;
  word-wrap: break-word;
  z-index: 9999;
  transition: all 0.2s ease;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: 1px solid #002FA7;
  line-height: 1.4;
}

.item-note-tooltip::before {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px 8px 0 8px;
  border-style: solid;
  border-color: #002FA7 transparent transparent transparent;
}

.item-note-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px 6px 0 6px;
  border-style: solid;
  border-color: white transparent transparent transparent;
}

.item-note-wrapper:hover .item-note-tooltip {
  visibility: visible;
  opacity: 1;
}

/* подгруппы */
.subgroup-buttons {
  display: flex;
  gap: 10px;
  margin-top: 5px;
}

.subgroup-btn {
  padding: 8px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.subgroup-btn:hover:not(.active) {
  border-color: #002FA7;
  color: #002FA7;
}

.subgroup-btn.active {
  background: #002FA7;
  color: white;
  border-color: #002FA7;
}

.subgroup-label {
  color: #027008;
  margin-bottom: 2px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.3;
  font-size: 10px;
}

/* чекбоксы недель */
.week-checkbox-group {
  margin-top: 0;
}

.week-checkboxes {
  display: flex;
  gap: 30px;
  padding: 10px 0;
}

.week-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  -webkit-user-select: none;
          user-select: none;
}

.week-checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #002FA7;
}

.week-checkbox-label span {
  font-weight: 500;
}

.week-checkbox-label:hover {
  color: #002FA7;
}

/* кнопки действий */
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.cancel-btn,
.save-btn,
.delete-btn {
  padding: 12px 30px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}

.cancel-btn {
  background: #f8f9fa;
  color: #666;
  border: 2px solid #e0e0e0;
}

.cancel-btn:hover:not(:disabled) {
  background: #e9ecef;
  border-color: #dc3545;
  color: #dc3545;
}

.save-btn {
  background: #002FA7;
  color: white;
}

.save-btn:hover:not(:disabled) {
  background: #001f7a;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

.delete-btn {
  background: #dc3545;
  color: white;
}

.delete-btn:hover:not(:disabled) {
  background: #c82333;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.cancel-btn:disabled,
.save-btn:disabled,
.delete-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}`, "",{"version":3,"sources":["webpack://./src/md-components/EditScheduleSection.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".edit-schedule-page {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  width: 110%;\n  max-width: 1900px;\n  margin: 20px auto;\n  min-height: 400px;\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.edit-schedule-main {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.edit-schedule-panel {\n  background: white;\n  border-radius: 10px;\n  padding: 30px 0px 30px 0px;\n}\n\n/* верхняя панель */\n.edit-schedule-top-panel {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n/* левая часть с кнопкой назад и выбором группы */\n.left-panel-section {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex: 1;\n}\n\n.back-button {\n  padding: 8px 16px;\n  background: white;\n  color: #002FA7;\n  border: 1px solid #002FA7;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 450;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100px;\n  height: 38px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.back-button:hover {\n  background: #f0f3ff;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 47, 167, 0.1);\n}\n\n.group-selection {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.group-selection label {\n  color: #002FA7;\n  font-weight: 600;\n  white-space: nowrap;\n  margin-bottom: 0;\n}\n\n.group-select {\n  min-width: 200px;\n  padding: 8px 12px;\n  border: 1px solid #002FA7;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #002FA7;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.3s;\n  height: 38px;\n}\n\n.group-select:focus {\n  outline: none;\n  border: 2px solid #002FA7;\n  color: #002FA7;\n}\n\n/* расписание */\n.schedule-grid-container {\n  margin-bottom: 40px;\n}\n\n.schedule-grid {\n  display: grid;\n  grid-template-columns: 120px repeat(6, 1fr);\n  gap: 1px;\n  background: #e0e0e0;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  width: 100%;\n}\n\n.grid-header {\n  background: #002FA7;\n  color: white;\n  padding: 15px 5px;\n  text-align: center;\n  font-weight: 600;\n  min-height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n}\n\n.grid-header.empty {\n  background: #f8f9fa;\n}\n\n.time-cell {\n  background: white;\n  padding: 10px;\n  text-align: center;\n  border-right: 1px solid #e0e0e0;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.pair-number {\n  font-weight: 600;\n  color: #002FA7;\n  margin-bottom: 5px;\n  font-size: 14px;\n}\n\n.pair-time {\n  font-size: 12px;\n  color: #666;\n}\n\n.schedule-cell {\n  background: white;\n  padding: 8px;\n  border-right: 1px solid #e0e0e0;\n  border-bottom: 1px solid #e0e0e0;\n  min-height: 100px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.schedule-cell:hover {\n  background: #f8f9fa;\n}\n\n.schedule-cell.selected {\n  background: #e8f0ff;\n  box-shadow: inset 0 0 0 2px #002FA7;\n}\n\n.schedule-cell.filled {\n  background: #f0f7ff;\n  cursor: pointer;\n}\n\n.schedule-cell.empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pair-info {\n  font-size: 11px;\n  line-height: 1.3;\n}\n\n.pair-info.both-weeks {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.week-label {\n  font-weight: 600;\n  font-size: 11px;\n  color: #666;\n  margin-bottom: 2px;\n}\n\n.pair-subject {\n  font-weight: 600;\n  color: #002FA7;\n  margin-bottom: 2px;\n  white-space: normal;\n  word-wrap: break-word;\n  line-height: 1.1;\n  font-size: 11px;\n}\n\n.pair-teacher {\n  color: #333;\n  margin-bottom: 2px;\n  white-space: normal;\n  word-wrap: break-word;\n  line-height: 1.1;\n  font-size: 10px;\n}\n\n.pair-room {\n  color: #666;\n  font-style: italic;\n  font-size: 10px;\n  margin-bottom: 10px;\n}\n\n.add-pair-btn {\n  color: #002FA7;\n  font-weight: 500;\n  padding: 5px 10px;\n  border: 1px dashed #002FA7;\n  border-radius: 4px;\n  background: #f8f9fa;\n  font-size: 12px;\n  text-align: center;\n}\n\n/* статус баннеры */\n.status-banner {\n  background: #e3f2fd;\n  color: #002FA7;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.status-banner.error {\n  background: #ffebee;\n  color: #c62828;\n}\n\n/* панель редактирования пары */\n.edit-pair-panel {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 25px;\n  margin-top: 30px;\n  border: 2px solid #e0e0e0;\n}\n\n.edit-pair-title {\n  color: #002FA7;\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  line-height: 1.4;\n}\n\n/* первая строка - преподаватели, предметы, аудитории */\n.edit-controls {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n  margin-bottom: 30px;\n}\n\n.control-group h4 {\n  color: #002FA7;\n  margin: 0 0 15px 0;\n  font-size: 16px;\n}\n\n/* поиск */\n.search-box {\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n.search-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.3s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 2px rgba(0, 47, 167, 0.2);\n}\n\n.no-results {\n  text-align: center;\n  padding: 20px;\n  color: #999;\n  font-style: italic;\n}\n\n/* списки преподавателей, предметов и аудиторий */\n.items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 200px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  padding: 4px;\n  overflow-x: visible !important;\n  overflow-y: auto;\n  z-index: 0;\n}\n\n.list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: white;\n  color: #333;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n  font-size: 14px;\n  position: relative;\n  flex-shrink: 0;\n  overflow: visible !important;\n}\n\n.list-item:hover:not(.active):not(:disabled) {\n  border-color: #002FA7;\n  background: #f0f3ff;\n}\n\n.list-item.active {\n  background: #002FA7;\n  color: white;\n  border-color: #002FA7;\n}\n\n.list-item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: #f5f5f5;\n}\n\n.item-name {\n  flex: 1;\n  text-align: left;\n}\n\n/* привязанная аудитория преподавателя - зеленое выделение */\n.list-item.owner-room {\n  background: #e8f5e9;\n  border-color: #4caf50;\n  color: #2e7d32;\n}\n\n.list-item.owner-room:hover:not(.active):not(:disabled) {\n  background: #c8e6c9;\n  border-color: #4caf50;\n  color: #1b5e20;\n}\n\n.list-item.owner-room.active {\n  background: #002FA7;\n  color: white;\n  border-color: #002FA7;\n}\n\n/* иконка примечания */\n.item-note-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n  flex-shrink: 0;\n}\n\n.item-note-icon {\n  width: 20px;\n  height: 20px;\n  transition: opacity 0.2s;\n}\n\n.item-note-tooltip {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 8px;\n  background: white;\n  color: #002FA7;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: normal;\n  white-space: normal;\n  min-width: 200px;\n  max-width: 350px;\n  width: max-content;\n  word-wrap: break-word;\n  z-index: 9999;\n  transition: all 0.2s ease;\n  pointer-events: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  border: 1px solid #002FA7;\n  line-height: 1.4;\n}\n\n.item-note-tooltip::before {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 8px 8px 0 8px;\n  border-style: solid;\n  border-color: #002FA7 transparent transparent transparent;\n}\n\n.item-note-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 6px 6px 0 6px;\n  border-style: solid;\n  border-color: white transparent transparent transparent;\n}\n\n.item-note-wrapper:hover .item-note-tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n/* подгруппы */\n.subgroup-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 5px;\n}\n\n.subgroup-btn {\n  padding: 8px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  background: white;\n  color: #333;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.subgroup-btn:hover:not(.active) {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.subgroup-btn.active {\n  background: #002FA7;\n  color: white;\n  border-color: #002FA7;\n}\n\n.subgroup-label {\n  color: #027008;\n  margin-bottom: 2px;\n  white-space: normal;\n  word-wrap: break-word;\n  line-height: 1.3;\n  font-size: 10px;\n}\n\n/* чекбоксы недель */\n.week-checkbox-group {\n  margin-top: 0;\n}\n\n.week-checkboxes {\n  display: flex;\n  gap: 30px;\n  padding: 10px 0;\n}\n\n.week-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 16px;\n  color: #333;\n  user-select: none;\n}\n\n.week-checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #002FA7;\n}\n\n.week-checkbox-label span {\n  font-weight: 500;\n}\n\n.week-checkbox-label:hover {\n  color: #002FA7;\n}\n\n/* кнопки действий */\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.cancel-btn,\n.save-btn,\n.delete-btn {\n  padding: 12px 30px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-size: 14px;\n}\n\n.cancel-btn {\n  background: #f8f9fa;\n  color: #666;\n  border: 2px solid #e0e0e0;\n}\n\n.cancel-btn:hover:not(:disabled) {\n  background: #e9ecef;\n  border-color: #dc3545;\n  color: #dc3545;\n}\n\n.save-btn {\n  background: #002FA7;\n  color: white;\n}\n\n.save-btn:hover:not(:disabled) {\n  background: #001f7a;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n.delete-btn {\n  background: #dc3545;\n  color: white;\n}\n\n.delete-btn:hover:not(:disabled) {\n  background: #c82333;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\n}\n\n.cancel-btn:disabled,\n.save-btn:disabled,\n.delete-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
